"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Modal = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents2 = require("rebass/styled-components");

var _md = require("react-icons/md");

var _IconButton = _interopRequireDefault(require("../atoms/IconButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var _StyledIconButton = (0, _styledComponents.default)(_IconButton.default).withConfig({
  displayName: "Modal___StyledIconButton",
  componentId: "f4esbs-0"
})(function (p) {
  return {
    position: 'absolute',
    top: 0,
    height: '28px',
    padding: 0,
    margin: 0,
    left: p._css,
    right: p._css2
  };
});

var ModalCloseButton = function ModalCloseButton(_ref) {
  var position = _ref.position,
      props = _objectWithoutProperties(_ref, ["position"]);

  return _react.default.createElement(_StyledIconButton, _extends({}, props, {
    _css: position === 'left' ? 0 : 'initial',
    _css2: position === 'right' ? 0 : 'initial'
  }));
};

var Modal = function Modal(_ref2) {
  var show = _ref2.show,
      closeButton = _ref2.closeButton,
      onHideClick = _ref2.onHideClick,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["show", "closeButton", "onHideClick", "children"]);

  return _react.default.createElement(_styledComponents2.Box, {
    sx: {
      position: 'relative',
      display: show ? 'inherit' : 'none'
    }
  }, _react.default.createElement(_styledComponents2.Box, {
    sx: _objectSpread({
      position: 'fixed',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      maxWidth: '100vw',
      maxHeight: '100vh',
      overflow: 'auto',
      zIndex: 1050,
      bg: 'white',
      borderRadius: 'radius'
    }, props)
  }, closeButton && _react.default.createElement(ModalCloseButton, {
    onClick: onHideClick,
    icon: _react.default.createElement(_md.MdClose, null),
    position: closeButton
  }), children), show && _react.default.createElement(_styledComponents2.Box, {
    onClick: onHideClick,
    sx: {
      position: 'fixed',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: 1040,
      bg: 'black',
      transition: 'opacity 5s linear',
      opacity: 0.5
    }
  }));
};

exports.Modal = Modal;
Modal.propTypes = {
  children: _propTypes.default.node,
  onHideClick: _propTypes.default.func,
  closeButton: _propTypes.default.string
};
var _default = Modal;
exports.default = _default;